import React from 'react';
import cn from 'classnames';
import styles from './index.module.scss';

/**
 * @description Design: https://www.figma.com/design/WMwUaibi2LRURMHSKSxcj5/SSDK-Components?node-id=2214-5561&m=dev
 *
 * @param {Object} props - Component properties
 * @param {import('utils/types').Mode} [props.mode] - Badge mode
 * @param {string} [props.className] - Additional class names to apply
 * @param {React.ReactNode} props.children - Content to display inside the badge
 */
export default function Badge({
  mode = 'light',
  className = '',
  children = null
}) {
  return (
    <div data-mode={mode} className={cn(styles.container, className)}>
      {children}
    </div>
  );
}
